import { Backdrop, Box, CircularProgress, Typography } from "@mui/material";
import { useRef } from "react";
import useElementHeight from "../../utils/hooks/useElementsHeight";
import { backDropStyle, greenColorStyle, redColorStyle, tableWrapper, textWrapperStyle, whiteWrapperStyle } from "./styled";

export interface IloadingProps {
  onClose: () => void,
  open: boolean,
  context: string,
  time: string,
}

export const Loading: React.FC<IloadingProps> = ({ onClose, open, context, time }) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const elementHeight = useElementHeight(elementRef) || 0;
  return (
    <Backdrop
      open={open}
      onClick={onClose}
      sx={backDropStyle}
    >
      <Box sx={whiteWrapperStyle}>
        <Box sx={{ textAlign: 'center' }} ref={elementRef}>
          <Typography component='span' sx={greenColorStyle}>Total Available Employees and Shortages</Typography>, shown in green,
          are updated on demand by clicking on the Refresh button at any time.
          <Typography component='span' sx={redColorStyle}> Job requirements</Typography>, shown in red, are refreshed on a fixed 15 minute schedule.
          Click on the Refresh button after the next scheduled
          refresh time to retrieve the most up-to-date job requirements.
          {context} <Typography component='span' sx={redColorStyle}>{time}</Typography>.
        </Box>
        <Box sx={tableWrapper(elementHeight)}>
          <Box sx={textWrapperStyle}>
            <CircularProgress />
          </Box>
        </Box>
      </Box>
    </Backdrop>
  )
}